import { render, staticRenderFns } from "./emailSMSConfirm.popup-chunk.vue?vue&type=template&id=77a97d5b&scoped=true"
import script from "./emailSMSConfirm.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./emailSMSConfirm.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./emailSMSConfirm.popup-chunk.vue?vue&type=style&index=0&id=77a97d5b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a97d5b",
  null
  
)

export default component.exports